/**
 * Shown instead of the whole app when the viewer's jurisdiction is "blocked" (#769). No wallet, no Hyperliquid
 * traffic: GeoGate renders only this.
 */
import { useT } from '../i18n/useT';
import { placeLabel } from './context';
import type { GeoDecision } from './policy';

export default function BlockedPage({ decision }: { decision: GeoDecision }) {
  const t = useT();
  return (
    <main
      className="mx-auto flex min-h-screen max-w-md flex-col items-center justify-center gap-3 px-4 text-center"
      data-testid="geo-blocked"
      data-geo-country={decision.country ?? ''}
    >
      <img src="/logo-mark.png" alt="" width={48} height={48} className="h-12 w-12" />
      <h1 className="text-lg font-semibold">{t('geo.blocked.title')}</h1>
      <p className="text-sm text-muted">{t('geo.blocked.body', { place: placeLabel(decision) })}</p>
      <p className="text-xs text-muted">{t('geo.blocked.help')}</p>
    </main>
  );
}
